import React from 'react'
import styled from 'styled-components'
import { mobile } from '../responsive';

const Container = styled.div`
      
`
const Text = styled.div`
    height: 30%;
    background-color: #0039a6;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    margin-top: 2px;
    ${mobile({ width: "100%" })}
`;


const SaleAnnouncement = () => {
  return (
    <Container>
        <Text>
            This item is exclusively for sale in our store, not for rental.
        </Text>
    </Container>
  )
}

export default SaleAnnouncement